/**
 * A solar reading counts only while its source still reports. A publisher at a steady
 * 0 W sends nothing new, and a dead one leaves its last watts behind (17.10.2026: the
 * Victron's totalPVPower stuck at 135 W from 17:37 into the night, the HM-1500 at 93 W
 * after its DTU lost power) — so a PV value not updated for 15 min is 0 W.
 */
export const PV_STALE_MS = 15 * 60_000

/** An ioBroker state { val, ts } → W, 0 when stale, null without a reading. */
export function freshPvW(state, now = Date.now()) {
  const v = Number(state?.val)
  if (state?.val == null || !Number.isFinite(v)) return null
  return state.ts && now - state.ts > PV_STALE_MS ? 0 : v
}
